import { Builder } from 'components/minute/builders/v2/Builder';
import { useDirectMarkerUpdates } from 'components/minute/builders/v2/useDirectMarkerUpdates';
import {
    V2_WALL_LINE_DEFAULT_WIDTH,
    useCreateWorldMarkerV2
} from 'hooks/marker/v2/useCreateWorldMarkerV2';
import { ICoordinates } from 'libs/types/map/mapTypes';
import polylabel from 'polylabel';
import { useContext } from 'react';
import { IWallV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

interface Props {
    isLine: boolean;
}

export const WallBuilder = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);
    const createWorldMarkerV2 = useCreateWorldMarkerV2();
    const directMarkerUpdates = useDirectMarkerUpdates();

    const updatePolygonDirectly = (markerId: string, newCoordinates: ICoordinates[]) => {
        directMarkerUpdates.updatePolygon(markerId, newCoordinates, 'wall', {
            closePolygon: false
        });
    };

    const updateLineDirectly = (markerId: string, newCoordinates: ICoordinates[]) => {
        directMarkerUpdates.updateLineWall(
            markerId,
            newCoordinates,
            V2_WALL_LINE_DEFAULT_WIDTH,
            false
        );
    };

    return (
        <Builder
            updateMarkerDirectly={props.isLine ? updateLineDirectly : updatePolygonDirectly}
            shouldBeClosedPolygon={!props.isLine}
            createWorldMarker={(coordinate) => {
                const marker = createWorldMarkerV2.createWall(
                    coordinate.lat,
                    coordinate.lng,
                    props.isLine ? 'line' : 'polygon'
                );
                return { markerId: marker.id };
            }}
            onFinished={(_marker) => {
                const marker = _marker as IWallV2WorldMarker;
                const wall = {
                    height: ctxEdit.markerDefault?.wall?.height ?? 1,
                    color: ctxEdit.markerDefault?.wall?.color ?? '#555',
                    opacity: ctxEdit.markerDefault?.wall?.opacity ?? 1
                };
                if (props.isLine) {
                    wall['width'] = ctxEdit.markerDefault?.wall?.width ?? 1;
                }
                const [centerLat, centerLng] = polylabel([
                    marker.elementData.coordinates.map(({ lat, lng }) => [lat, lng])
                ]);
                ctxEdit.markerCreation.finish({
                    ...marker,
                    lat: centerLat,
                    lng: centerLng,
                    elementData: {
                        ...marker.elementData,
                        nonTransformedCoordinates: marker.elementData.coordinates,
                        wall: {
                            ...marker.elementData.wall,
                            ...wall
                        }
                    }
                });
            }}
        />
    );
};
